// No need for hardcoding, values are all in correct order
const numDesigns = 4;
const patriotic = [];

for ( let i = 0; i < numDesigns; i++ ) {
  const number = 100 + i;
  patriotic.push( {
    number: `HP${number}`
  });
}

export default patriotic;